/* eslint-disable no-useless-computed-key */
import { Box, Button, CircularProgress, IconButton, LinearProgress, Switch, Tooltip, Typography, TextField, Collapse } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import FilledSelectOption from '../../../components/input/FilledSelectOption';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Api } from '../../../api/api';
import { endPoints } from '../../../api/apiEndpoints';
import ButtonCom from '../../../components/button/ButtonCom';
import InputControl from '../../../components/input/InputControl';
import Card from '../../../components/layout/Card';
import TransitionsModal from '../../../components/modal/Modal';
import { Flex, Grid, MarginHandler } from '../../../styledComponents';
import { colors, fonts } from '../../../utils';
// import { setAllPostCategories } from '../../../redux/slices/posts/posts';
import EditIcon from '@mui/icons-material/Edit';
import moment from 'moment';
import ReadMoreReact from 'read-more-react/dist/components/ReadMoreReact';
import DeleteModal from '../../../components/deletemodal/DeleteModal';
import Table from '../../../components/table/Table';
import { setAllDocuments } from '../../../redux/slices/shareholderRights/shareholderRights';
import { successNotify } from '../../../utils/helper';


const Documents = () => {
	const dispatch = useDispatch();
	const { clientId, userId, fullName } = useSelector((state) => state?.activeAccount);
	const { primaryFont } = fonts;

	const { colorWhite, colorPrimary, colorGreenGradient } = colors;

	const { documents } = useSelector((state) => state.shareholderRights);
	const [openModal, setOpenModal] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [isEditing, setIsEditing] = useState(false);
	const [isLoadingDoc, setIsLoadingDoc] = useState(false);
	const [disableUpload, setDisableUpload] = useState(false);
	const [disableUrlInput, setDisableUrlInput] = useState(false);
	const [isLoadingDocUr, setIsLoadingDocUr] = useState(false);
	const [disableUploadUr, setDisableUploadUr] = useState(false);
	const [disableUrlInputUr, setDisableUrlInputUr] = useState(false);
	const [isLoadingModal, setIsLoadingModal] = useState(false);
	const [formData, setFormData] = useState({
		icon: '',
		title: '',
		description: '',
		url_en: '',
		url_ur: '',
	});
	const [currentParams, setCurrentParams] = useState({
		limit: 10,
		page: 1,
		totalPages: 0,
		totalRecords: 0,
	});
	const [filters, setFilters] = useState({
		search: '',
		status: '',
		date_from: null,
		date_to: null,
	});
	const [filtersOpen, setFiltersOpen] = useState(false);

	const handleFilterChange = (e) => {
		setFilters((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	const handleFilterDateChange = (name, value) => {
		setFilters((prevState) => ({
			...prevState,
			[name]: value,
		}));
	};

	const handleApplyFilters = () => {
		getDocuments(currentParams.limit, 1, filters);
	};

	const handleClearFilters = () => {
		const clearedFilters = {
			search: '',
			status: '',
			date_from: null,
			date_to: null,
		};
		setFilters(clearedFilters);
		getDocuments(currentParams.limit, 1, clearedFilters);
	};

	const handleCloseModal = () => {
		setOpenModal(false);
		setIsEditing(false);
	};

	const handleChange = (e) => {
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
		if (e.target.name == "url_en" && e.target.value) {
			setDisableUpload(true);
			setDisableUrlInput(false);
		} else if (e.target.name == "url_ur" && e.target.value) {
			setDisableUploadUr(true);
			setDisableUrlInputUr(false);
		} else {
			setDisableUpload(false);
			setDisableUploadUr(false);
		}
	};

	const getDocuments = async (limit, page, filterParams = filters) => {
		setIsLoading(true)
		try {

			await Api.post(`${endPoints?.shareHolderRights?.fetchAll}`, {
				"type": "document",
				"status": filterParams.status || "all",
				"limit": limit || 10,
				"page": page || 1,
				"search": filterParams.search || null,
				"date_from": filterParams.date_from ? dayjs(filterParams.date_from).format('YYYY-MM-DD') : null,
				"date_to": filterParams.date_to ? dayjs(filterParams.date_to).format('YYYY-MM-DD') : null,
				user_id: clientId == 0 ? null : userId

			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					dispatch(
						setAllDocuments(
							response?.data?.data?.shareholderss?.data?.map((d, index) => ({
								index: index + 1,
								id: d?.id,
								icon: d?.icon,
								title: d?.title,
								description: d?.description,
								url_en: d?.url_en,
								url_ur: d?.url_ur,
								dt: d?.dt,
								is_enabled: d?.is_enabled,
								creator_name: d?.creator_name,
							})
							),
						),
					);
					const { page, limit, totalPages, totalRecords } = response?.data?.data?.shareholderss;
					setCurrentParams({ page, limit, totalPages, totalRecords });

					setIsLoading(false)

				})
				.catch((error) => {
					// if (error?.response?.status === 400) {
					// 	errorNotify(error?.response?.data);
					// 	setDisabledBtn(false);
					// }
					// setErrMsg(error?.response?.data?.message || errorMsg);
				});
		} catch (err) {
			// setErrMsg('Login Failed');
			// setDisabledBtn(false);
		}
	};


	const handleDelete = async () => {


	};

	const handleDocUpload = (event, urlName) => {

		if (urlName === "url_en") {
			setIsLoadingDoc(true)
		} else {
			setIsLoadingDocUr(true)
		}
		if (event.target.files.length > 0) {
			let formData = new FormData();
			let file = event.target.files[0];
			let fileName = file.name.replace(/\s/g, '');
			let timestampedFileName = `${new Date().getTime()}_${fileName}`;

			formData.append('file', file, timestampedFileName);
			Api.post(endPoints?.file?.upload, formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
					'xt-user-token': null
				}
			})
				.then((response) => {
					if (urlName === "url_en") {
						setIsLoadingDoc(false)
						setDisableUrlInput(true);
						setDisableUpload(false);
						setFormData((prevState) => ({
							...prevState,
							"url_en": response.data.data.link,
						}));
					} else {
						setIsLoadingDocUr(false)
						setDisableUrlInputUr(true);
						setDisableUploadUr(false);
						setFormData((prevState) => ({
							...prevState,
							"url_ur": response.data.data.link,
						}));
					}

					successNotify("Document Uploaded Successfully")

				})
				.catch((error) => {

				});

		}
	};
	const handleCreateModal = () => {
		setFormData({ icon: '', title: '', description: '', url_en: '', url_ur: '' })
		setOpenModal(true)
		setIsEditing(false);
	};
	const handleEditModal = (val) => {
		setFormData({ icon: val.icon, title: val.title, description: val.description, url_en: val.url_en, url_ur: val.url_ur, id: val.id })
		setOpenModal(true)
		setIsEditing(true);
	};


	const handleOpenDeleteModal = (val) => {
		setFormData({ id: val.id })
		setOpenDeleteModal(true)
	};
	const handleCloseDeleteModal = () => {
		setFormData({ icon: '', title: '', description: '', url_en: '', url_ur: '' })
		setOpenDeleteModal(false)
	};

	const handleSubmit = async () => {
		setIsLoadingModal(true)
		if (!isEditing) {


			try {

				await Api.post(endPoints?.shareHolderRights?.createDoc, {
					...formData,
					"type": "document",
					creator_id: 1,
				}, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						getDocuments();
						successNotify("Document Created Successfully")
						setIsLoadingModal(false)
					})
					.catch((error) => {

					});

			} catch (err) {
			}

		} else {


			try {

				await Api.post(endPoints?.shareHolderRights?.updateDoc, {
					...formData,
					"type": "document",
					"creator_id": 1,
					"is_enabled": true,
					"is_deleted": false,
				}, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						getDocuments();
						successNotify("Document Updated Successfully")
						setIsLoadingModal(false)
					})
					.catch((error) => {

					});

			} catch (err) {
			}
		}
	};

	useEffect(() => {
		getDocuments();
	}, [])

	const handleSwitchClick = (event) => {
		event.stopPropagation();
	};
	const handleChangeTableSwitch = async (event, val) => {

		try {

			await Api.post(endPoints?.shareHolderRights?.deleteDoc, {
				id: val.id,
				status: event.target.checked
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					successNotify("Document Status Updated Successfully")
					handleCloseDeleteModal();
					getDocuments();

				})
				.catch((error) => {

				});

		} catch (err) {
		}
	}

	const column = [
		{
			title: 'Id',
			field: 'id',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.id}</h4>,
		},
		// {
		// 	title: 'Category Id',
		// 	field: 'category_id',
		// 	render: (rowData) => <h4 className='font-face-B'>{rowData?.category_id}</h4>,
		// },
		{
			title: 'Title',
			field: 'title',
			render: (rowData) => <h4 className='font-face-R'>{
				rowData?.title?.length > 15 ?
					<ReadMoreReact
						text={rowData?.title}
						min={10}
						ideal={15}
						max={rowData?.title?.length}
						readMoreText="Read More"
					/> : rowData?.title}</h4>,
		},
		{
			title: 'Description',
			field: 'description',
			render: (rowData) => <h4 className='font-face-R'>{
				rowData?.description?.length > 15 ?
					<ReadMoreReact
						text={rowData?.description}
						min={10}
						ideal={15}
						max={rowData?.description?.length}
						readMoreText="Read More"
					/> : rowData?.description}</h4>,
		},
		// {
		// 	title: 'Url',
		// 	field: 'url_en',
		// 	render: (rowData) => <h4 className='font-face-R'>{rowData?.url_en}</h4>,
		// },
		{
			title: 'Date',
			field: 'dt',
			width: "10%",
			render: (rowData) => <h4 className='font-face-R'>{moment(rowData?.dt).format("DD-MM-YYYY")}</h4>,
		},
		{
			title: 'Creator',
			field: 'creator_name',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.creator_name}</h4>,
		},
		{
			title: 'Edit',
			field: 'edit',
			filtering: false,
			render: (rowData) => (
				<Tooltip title='Edit'>
					<IconButton onClick={() => handleEditModal(rowData)} aria-label='Edit'>
						<EditIcon />
					</IconButton>
				</Tooltip>
			),
		},
		{
			title: 'Status',
			field: 'enabled',
			render: (rowData) =>
				<Switch onClick={handleSwitchClick} onChange={(event) => handleChangeTableSwitch(event, rowData)} checked={rowData?.is_enabled} name='enabled' />,
		},

	];



	return (
		<>

			<Card margin='3rem 1.5rem' padding='3rem'>

				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>
					<ButtonCom onClickHandler={handleCreateModal} btnTitle={"Create"} />
				</Flex>

				{/* Filters Section */}
				<Box sx={{ mb: 3, backgroundColor: '#f5f5f5', borderRadius: '8px', overflow: 'hidden' }}>
					<Box
						sx={{
							p: 2,
							cursor: 'pointer',
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							'&:hover': { backgroundColor: '#ebebeb' },
							transition: 'background-color 0.2s ease'
						}}
						onClick={() => setFiltersOpen(!filtersOpen)}
					>
						<Flex ai='center' gap='0.5rem'>
							<FilterListIcon sx={{ color: '#666' }} />
							<Typography variant='h6' sx={{ fontSize: '1.6rem', fontWeight: 600, color: '#333' }}>
								Filter Documents
							</Typography>
						</Flex>
						{filtersOpen ? <ExpandLessIcon sx={{ color: '#666' }} /> : <ExpandMoreIcon sx={{ color: '#666' }} />}
					</Box>

					<Collapse in={filtersOpen} timeout={300}>
						<Box sx={{ p: 2, pt: 1 }}>
							{/* Search Bar */}
							<Box sx={{ mb: 2 }}>
								<InputControl
									state={filters.search}
									onChange={handleFilterChange}
									label='Search by Title'
									name='search'
								/>
							</Box>

							{/* Dropdown Filters */}
							<Grid gtc='repeat(auto-fit, minmax(18rem, 1fr))' gap='1.5rem'>
								<FilledSelectOption
									label='Status'
									state={filters.status}
									onChange={handleFilterChange}
									options={[
										{ id: 'true', description: 'Active' },
										{ id: 'false', description: 'Inactive' },
									]}
									maxWidth='100%'
									minWidth='100%'
									width='100%'
									name='status'
								/>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DesktopDatePicker
										label='Date From'
										value={filters.date_from}
										onChange={(value) => handleFilterDateChange('date_from', value)}
										renderInput={(params) => <TextField {...params} size='small' />}
									/>
								</LocalizationProvider>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DesktopDatePicker
										label='Date To'
										value={filters.date_to}
										onChange={(value) => handleFilterDateChange('date_to', value)}
										renderInput={(params) => <TextField {...params} size='small' />}
									/>
								</LocalizationProvider>
							</Grid>

							<Flex jc='space-between' ai='center' gap='1rem' mt='1.5rem'>
								<Button
									variant='text'
									startIcon={<ClearIcon />}
									onClick={handleClearFilters}
									sx={{ fontSize: '1.2rem', textTransform: 'none', color: '#666' }}>
									Clear All
								</Button>
								<Button
									variant='contained'
									color='success'
									startIcon={<SearchIcon />}
									onClick={handleApplyFilters}
									sx={{ fontSize: '1.2rem', textTransform: 'none', px: 3 }}>
									Apply Filters
								</Button>
							</Flex>
						</Box>
					</Collapse>
				</Box>

				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>

					<TransitionsModal
						open={openModal}
						// handleOpen={handleOpenModal}
						handleClose={handleCloseModal}
						modalTitle={isEditing ? "Edit Document" : "Create Document"}
						isLoading={isLoadingModal}
					>

						<Grid gtc='repeat(auto-fit, minmax(40rem, 1fr))' padding='2rem'>
							{/* <MarginHandler width='100%'>
								<InputControl
									state={formData?.icon}
									onChange={handleChange}
									label='Icon'
									name='icon'
								/>
							</MarginHandler> */}
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.title}
									onChange={handleChange}
									// inputProps={{ maxLength:150 }}
									label='Title'
									name='title'
								/>
							</MarginHandler>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.description}
									onChange={handleChange}
									label='Description'
									name='description'
									// inputProps={{ maxLength: 250 }}
									multiline
									rows={1}
								/>
							</MarginHandler>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.url_en}
									onChange={handleChange}
									disabled={disableUrlInput}
									label='English Url'
									name='url_en'
								/>
							</MarginHandler>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.url_ur}
									onChange={handleChange}
									disabled={disableUrlInputUr}
									label='Urdu Url'
									name='url_ur'
								/>
							</MarginHandler>


							{isLoadingDoc ?
								<CircularProgress sx={{ margin: "auto" }} color="success" />
								:
								<>
									<input
										accept="file"
										style={{ display: 'none' }}
										id="doc-upload"
										type="file"
										onChange={(event) => handleDocUpload(event, 'url_en')}
										disabled={disableUpload}
									/>
									<label htmlFor="doc-upload">
										<Button
											variant="contained"
											component="span"
											// color='success'
											disabled={disableUpload}
											style={{ width: '99%', marginLeft: '2px', paddingLeft: '2px', fontSize: "1em" }}
										>
											Upload English Document
										</Button>
									</label>

								</>
							}

							{isLoadingDocUr ?
								<CircularProgress sx={{ margin: "auto" }} color="success" />
								:
								<>
									<input
										accept="file"
										style={{ display: 'none' }}
										id="doc-upload2"
										type="file"
										onChange={(event) => handleDocUpload(event, 'url_ur')}
										disabled={disableUploadUr}
									/>
									<label htmlFor="doc-upload2">
										<Button
											variant="contained"
											component="span"
											// color='success'
											disabled={disableUploadUr}
											style={{ width: '99%', marginLeft: '2px', paddingLeft: '2px', fontSize: "1em" }}
										>
											Upload Urdu Document
										</Button>
									</label>

								</>
							}


							<MarginHandler mt="2rem">
								<Button
									color='primary'
									variant='contained'
									onClick={handleSubmit}
									style={{
										// backgroundColor: colorPrimary,
										background: colorGreenGradient,
										fontSize: '1.6rem',
										textTransform: 'none',
										padding: '0.7rem 2rem',
										color: colorWhite,
										borderRadius: '0.5rem',
										float: "right"
									}}
									disabled={!formData.title}
									className='font-face-R'>
									{isEditing ? "Update " : "Create "}
								</Button>
							</MarginHandler>

						</Grid>
					</TransitionsModal>
				</Flex>






				<DeleteModal
					open={openDeleteModal}
					handleClose={handleCloseDeleteModal}
					handleDelete={handleDelete}
				/>


				{isLoading ?
					<Box sx={{ m: '5rem' }}>
						<LinearProgress color="success" />
					</Box>
					:
					<Table
						columns={column}
						tableData={documents?.map((item) => ({ ...item }))}
						sorting
						columnsButton
						padding="3rem"
						showTitle
						paginationType='normal'
						titleHeading="Documents"
						showToolbar={true}
						pageSize={currentParams.limit}
						onChangeRowsPerPage={(event) => getDocuments(parseInt(event.target.value, 10), 1)}
						totalRecords={currentParams.totalRecords}
						handlePageChange={(event, newPage) => getDocuments(currentParams.limit, newPage + 1)}
						curPage={currentParams.page - 1}
					/>
				}








			</Card>
		</>
	);
};

export default Documents;
